import React from "react";
import { Button, DatePicker, InputNumber, Space } from "antd";
import dayjs from "dayjs";

export function parseTableRangeFilter(filters, key) {
  const raw = filters?.[key];
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (value == null || value === false) return { min: undefined, max: undefined };
  if (typeof value === "object") {
    const min = value.min;
    const max = value.max;
    return {
      min: min == null || min === "" ? undefined : Number(min),
      max: max == null || max === "" ? undefined : Number(max),
    };
  }
  return { min: undefined, max: undefined };
}

export function rangeFilterValue(min, max) {
  if (min == null && max == null) return null;
  return [{ min, max }];
}

function stopRowClick(event) {
  event?.stopPropagation?.();
}

export function numericRangeFilterDropdown({ minPlaceholder = "Min", maxPlaceholder = "Max", prefix } = {}) {
  return ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const value = selectedKeys?.[0] && typeof selectedKeys[0] === "object" ? selectedKeys[0] : {};
    return (
      <div style={{ padding: 8, width: 220 }} onClick={stopRowClick} onMouseDown={stopRowClick}>
        <Space direction="vertical" size={8} style={{ width: "100%" }}>
          <InputNumber
            style={{ width: "100%" }}
            placeholder={minPlaceholder}
            prefix={prefix}
            min={0}
            value={value.min}
            onChange={(min) => setSelectedKeys([{ ...value, min }])}
          />
          <InputNumber
            style={{ width: "100%" }}
            placeholder={maxPlaceholder}
            prefix={prefix}
            min={0}
            value={value.max}
            onChange={(max) => setSelectedKeys([{ ...value, max }])}
          />
          <Space>
            <Button size="small" type="primary" onClick={() => confirm()}>
              Filter
            </Button>
            <Button
              size="small"
              onClick={() => {
                clearFilters?.();
                confirm();
              }}
            >
              Reset
            </Button>
          </Space>
        </Space>
      </div>
    );
  };
}

export function toDayjsRange(from, to) {
  const start = from ? (dayjs.isDayjs(from) ? from : dayjs(from)) : null;
  const end = to ? (dayjs.isDayjs(to) ? to : dayjs(to)) : null;
  if (start?.isValid?.() && end?.isValid?.()) return [start, end];
  if (start?.isValid?.()) return [start, null];
  if (end?.isValid?.()) return [null, end];
  return null;
}

/** Column date-range filter that writes the same from/to the toolbar uses. */
export function dateRangeFilterDropdown({ value, onChange }) {
  return ({ confirm, clearFilters }) => (
    <div style={{ padding: 8 }} onClick={stopRowClick} onMouseDown={stopRowClick}>
      <DatePicker.RangePicker
        allowClear
        value={Array.isArray(value) ? value : toDayjsRange(value?.start, value?.end)}
        onChange={(dates) => onChange?.(dates || null)}
      />
      <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
        <Button size="small" type="primary" onClick={() => confirm()}>
          Filter
        </Button>
        <Button
          size="small"
          onClick={() => {
            onChange?.(null);
            clearFilters?.();
            confirm();
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

export function formatNaira(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `₦${n.toLocaleString()}`;
}
